import React from 'react';
import { render } from 'react-dom';
import App from './App';
import { setEnvironment } from './Config/Environment';
setEnvironment().then(() => {
    const container = document.getElementById('my-pages-component');
    if (container) {
        render(React.createElement(App, null), container);
    }
});
